/* eslint-disable no-redeclare */
import React from 'react'
import { Field } from 'redux-form'
import { pt, buildPropTypes } from 'common-data/proptypehelpers'
import { FieldLayoutBox, FieldLayoutGroup } from './FieldLayoutBox'
import { FieldValueFormatter, FieldValueParser } from './FieldValueConverters'
import { DebounceInput } from 'react-debounce-input'
import _ from 'common-tools/LodashHelper'
import clsx from 'clsx'

export class TextBoxClass extends React.Component {
  static propTypes = buildPropTypes([

  ], {
    type: pt.string
  })

  onBlur = (e) => {
    const { input: { onBlur } } = this.props
    if (_.isFunction(onBlur)) {
      let newValue = _.trim(e.target.value)
      onBlur(newValue)
    }
  }

  onChange (e) {
    const { input: { onChange } } = this.props

    if (_.isFunction(onChange)) {
      if (e.target) {
        onChange(e.target.value)
      } else {
        onChange(undefined)
      }
    }
  }

  render () {
    const { type, delay = false, delayMinLength = 2, delayTimeOutMS = 300, groupButton, groupLabel, autocomplete = 'off', ...rest } = this.props
    var inputType = type || 'text'
    return (
      <FieldLayoutBox {...rest}>
        {({ showError, value, name, placeHolder, loading, readonly, testId, maxLength, onBlur }) => {
          if (readonly) {
            return <FieldLayoutGroup groupButton={groupButton} groupLabel={groupLabel}>
              <input data-tid={testId} className={clsx(showError && 'is-invalid-input', (groupButton || groupLabel) && 'input-group-field')}
                type={inputType} readOnly name={`view${name}`} id={`view${name}`} value={value} />
            </FieldLayoutGroup>
          } else {
            if (delay === true) {
              return <DebounceInput
                className={clsx(showError && 'is-invalid-input')}
                minLength={delayMinLength}
                debounceTimeout={delayTimeOutMS}
                data-tid={testId}
                name={`text${name}`}
                id={`text${name}`}
                placeholder={placeHolder}
                onChange={this.onChange}
                onBlur={this.onBlur}
                type={inputType}
                value={value} />
            } else {
              return <FieldLayoutGroup groupButton={groupButton} groupLabel={groupLabel}>
                <input data-tid={testId} type={inputType} className={clsx(showError && 'is-invalid-input', (groupButton || groupLabel) && 'input-group-field')}
                  name={`text${name}`} id={`text${name}`} placeholder={placeHolder} onChange={this.onChange} value={value} maxLength={maxLength} onBlur={this.onBlur} autoComplete={autocomplete} />
              </FieldLayoutGroup>
            }
          }
        }}
      </FieldLayoutBox>
    )
  }
};

export const TextBox = ({ parse, format, fieldType, name, namePrefix, ...rest }) => { return <Field name={namePrefix ? `${namePrefix}.${name}` : name} parse={fieldType ? FieldValueParser(fieldType) : parse} format={fieldType ? FieldValueFormatter(fieldType) : format} {...rest} component={TextBoxClass}/> } // eslint-disable-line
export default TextBox
